import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import QuickMenu from 'common/components/QuickMenu/QuickMenu';
import Part11Indicator from 'common/components/Part11Indicator/Part11Indicator';
import DialogDeactivateUser from 'common/components/DialogDeactivateUser/DialogDeactivateUser';

import {
    resetUserPassword,
    resendRegistrationEmail,
    setUserActive,
    changeUserActive,
    getUsersTaskCount
} from 'part11/actions/users';
import styles from './UserQuickActions.scss';

function QuickActionLabel({ labelText }) {
    return (
        <div className={styles.quickActionLabel} data-cy="UserInfo-UserQuickActions">
            <span data-cy="UserInfo-labelText">{ labelText }</span>
            <Part11Indicator className={styles.part11Icon} />
        </div>
    );
}

export class UserQuickActions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isDialogOpen: false,
            taskCount: 0,
        };

        this.handleSetUserActive = this.handleSetUserActive.bind(this);
    }

    async componentDidMount() {
        const taskCount = await this.getTaskCount();
        this.setState({
            taskCount
        });
    }

    getEditPath () {
        const { user } = this.props;
        const editPath = `/admin/users/${user.id}/edit`;
        return editPath;
    }

    async getTaskCount() {
        return await this.props.getUsersTaskCount(this.props.user);
    }

    handleSetUserActive() {
        this.setState({
            isDialogOpen: false,
        });
        this.props.setUserActive(this.props.user, this.props.institutionIdi);
    }

    handleChangeUserActive() {
        if(this.state.taskCount && this.props.user.isActive) {
            return this.setState({
                isDialogOpen: true,
            });
        }
        this.props.changeUserActive(this.props.user, this.props.institutionId);
    }

    render() {
        const editPath = this.getEditPath();
        const { user } = this.props;

        const options = user.isSso ?
            [{
                label: 'Edit',
                handler: this.props.push.bind(this, editPath)
            }, {
                label: <QuickActionLabel labelText={user.isActive ? 'Deactivate' : 'Activate'} />,
                handler: this.handleChangeUserActive.bind(this)
            }, {
                label: 'Account Reset',
                handler: this.props.resendRegistrationEmail.bind(this, user)
            }]
            :
            [{
                label: 'Edit',
                handler: this.props.push.bind(this, editPath)
            }, {
                label: <QuickActionLabel labelText="Reset Password" />,
                handler: this.props.resetUserPassword.bind(this, user)
            }, {
                label: <QuickActionLabel labelText={user.isActive ? 'Deactivate' : 'Activate'} />,
                handler: this.handleChangeUserActive.bind(this)
            }, {
                label: 'Account Reset',
                handler: this.props.resendRegistrationEmail.bind(this, user)
            }];

        return (
            <Fragment data-cy="UserInfo-Fragment">
                <QuickMenu headerText="Quick User Actions" theme="primary" options={options} />
                <DialogDeactivateUser 
                    isOpen={this.state.isDialogOpen}
                    handleConfirm={this.handleSetUserActive}
                    taskCount={this.state.taskCount}
                    handleOnClose={() => this.setState({isDialogOpen: false})}
                />
            </Fragment>
        );
    }
}

UserQuickActions.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(null, {
    push,
    resetUserPassword,
    resendRegistrationEmail,
    setUserActive,
    changeUserActive,
    getUsersTaskCount
})(UserQuickActions);
